class SlidingDoor {
  constructor() {
    this.buyingJourney = document.querySelector("buying-journey");
    this.configurationPopup = document.querySelector("configuration-popup");
    this.skipAstragalStep = false;
    this.aluminiumBifold = this;
    this.buyingJourneyApi = this.buyingJourney.buyingJourneyApi;
    // Dispatch the change event immediately after setting up the event listener
    this.finishStepAt = 9;
    //Object holding the information for whole Buying Journey.
    this.buyingJourneyObject = {
      id: null,
      title: null,
      productType: "sliding_doors",
      panelInfo: { panelWidth: null, panelHeight: null, value: null },
      panelSize: {
        value: null,
        variantId: null,
        totalPrice: 0,
        quantity: 1,
        panelImage: null,
      },
      panelOutsideColour: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      panelInsideColour: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      panelHandle: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelGlass: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      blinds: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      trickleVents: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      profileAddons: { top: null, topPrice: 0, value: null },
      postCode: { value: null },
      cill: { value: null, totalPrice: 0, variantId: null, quantity: 1 },
      accessIssue: { value: null, orderNote: null },
      gtAccessQoute: {
        firstName: null,
        lastName: null,
        mobile: null,
        email: null,
      },
      totalPrice: 0,
      invoiceUrl: null,
    };

    // step functions that will perform calculation based on selection in previous steps
    this.stepActions = {
      0: () =>
        this.getWindowSize(
          this.buyingJourneyObject,
          this.buyingJourney.querySelectorAll(".step-size input")
        ),
      1: this.calculatePanelSize.bind(this),
      2: this.getOrientation.bind(this),
      3: this.getOutsideColor.bind(this),
      4: this.getInsideColor.bind(this),
      5: this.getPanelHandle.bind(this),
      6: this.getGlassType.bind(this),
      7: this.getThreshold.bind(this),
      8: this.getBarsFittingQuantity.bind(this),
      9: this.getTrickleVents.bind(this),
      10: this.getCill.bind(this),
      11: this.getpostcode.bind(this),
      12: this.getGatewayAccessQuote.bind(this),
      13: this.buyingJourney.handleAddMoreProducts.bind(this.buyingJourney),
      14: this.buyingJourney.readyQuoteOverview.bind(this.buyingJourney),
    };
  }

  //First step assign event listener to input fields
  getWindowSize(productObject, inputs) {
    console.log("Sliding doors: Panel width and height");

    inputs.forEach((input) => {
      if (input.name == "panel-width") {
        input.value = productObject.panelInfo.panelWidth;
      }
      if (input.name == "panel-height") {
        input.value = productObject.panelInfo.panelHeight;
      }

      this.validateInput(productObject, input)
        ? this.buyingJourney.setActiveNextButton()
        : this.buyingJourney.setDisableNextButton();
      input.addEventListener("input", () =>
        this.validateInput(productObject, input)
          ? this.buyingJourney.setActiveNextButton()
          : this.buyingJourney.setDisableNextButton()
      );

      input.dispatchEvent(this.buyingJourney.changeEvent);
    });
  }
  getSlidingDoorProduct(panelSizeValue, handle) {
    const width =
      Math.ceil(this.buyingJourneyObject.panelInfo.panelWidth / 200) * 200;
    const height =
      Math.ceil(this.buyingJourneyObject.panelInfo.panelHeight / 100) * 100;
    const isExtraPanel = handle.includes("all-sliding");
    const extraPanelCost = panelSizeValue > 3 ? 100 : 50;
    const allSlidingDoorProducts = JSON.parse(
      document.querySelector("#sliding-doors-products").textContent
    );
    const overSizedVariants = JSON.parse(
      document.querySelector("#oversized-variants").textContent
    );
    const sixMGlassVariants = JSON.parse(
      document.querySelector("#six_m_glass_variants").textContent
    );
    let variant = null;
    const product = allSlidingDoorProducts.find((item) => {
      if (item.handle.includes(`${panelSizeValue}-panel`)) {
        const selectedVariant = item.variants.find((variant) => {
          return +variant.option1 === width && +variant.option2 === height;
        });

        if (selectedVariant) {
          variant = selectedVariant;
        }

        return selectedVariant;
      }
    });

    if (!product || variant.price === 0) return null;
    return {
      extraPanelCost: isExtraPanel ? extraPanelCost : 0,
      variant,
      product,
      isOversized: overSizedVariants.includes(String(variant.id)),
      isSixMGlass: sixMGlassVariants.includes(String(variant.id)),
    };
  }
  //Based on added width and height calcualte the Panel Size for Step 2
  calculatePanelSize() {
    console.log("No. of panels ");
    const panels = this.buyingJourney.querySelectorAll(
      ".offered-product-wrapper .panel-wrapper"
    );

    panels.forEach((panel) => {
      if (panel) {
        const panelSizeInput = panel.querySelector('input[name="panel_size"]');
        panel.classList.add("hidden");
        const panelSizeValue = parseInt(panelSizeInput.dataset.panelSize) || 0;
        const dataObject = this.getSlidingDoorProduct(
          panelSizeValue,
          panelSizeInput.id
        );
        if (dataObject) {
          const input = panel.querySelector("input");
          panel.classList.remove("hidden");

          let panelFinalPrice = this.convertPrice(
            dataObject.variant.price / 100
          );
          panelFinalPrice = this.convertPrice(panelFinalPrice + dataObject.extraPanelCost);
          panel.querySelector(
            ".panel-price"
          ).innerHTML = `+ £${panelFinalPrice}`;
          input.dataset.price = panelFinalPrice;
          input.setAttribute("data-oversized", dataObject.isOversized);
          input.setAttribute("data-six-m-glass", dataObject.isSixMGlass);
          input.setAttribute("data-variant-id", dataObject.variant.id);
        }
      }
    });
    this.setupOptionListeners('input[name="panel_size"]');
  }

  //Step 4: show outside colour and get selected orientation
  getOrientation() {
    console.log("Outside Colour");
    if (this.buyingJourneyObject.panelOutsideColour.variantId != null) {
      const selectedColorOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelOutsideColour.variantId +
        '"]'
      );
      selectedColorOption.checked = true;
      selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
      console.log(selectedColorOption);
    }

    const selectedPanel = this.buyingJourney.querySelector(
      'input[name="panel_size"]:checked'
    );
    if (selectedPanel) {
      this.buyingJourneyObject.panelSize.value =
        selectedPanel.dataset.panelSize || null;
      this.buyingJourneyObject.panelInfo.value = selectedPanel.value || null;
      this.buyingJourneyObject.panelInfo.isOversized =
        selectedPanel.dataset.oversized === "true";
      this.buyingJourneyObject.panelInfo.isSixMGlass =
        selectedPanel.dataset.sixMGlass === "true";
      this.buyingJourneyObject.panelSize.variantId =
        selectedPanel.dataset.variantId || null;
      this.buyingJourneyObject.panelSize.totalPrice =
        selectedPanel.dataset.price;
      this.buyingJourneyObject.panelSize.panelImage =
        selectedPanel.nextElementSibling.querySelector("img").src;
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners(
      'input[name="sliding_doors:_panel_outside_colour"]'
    );
  }

  //Step 5: show inside colour and get selected outside colour
  getOutsideColor() {
    const colorOptions = {
      "Anthracite Grey": ["White", "Anthracite Grey"],
      Black: ["White", "Black"],
      White: ["White"],
    };
    console.log("Inside Colour");
    if (this.buyingJourneyObject.panelInsideColour.variantId != null) {
      const selectedColorOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelInsideColour.variantId +
        '"]'
      );
      selectedColorOption.checked = true;
      selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    let selectedOutsideColor = this.buyingJourney.querySelector(
      'input[name="sliding_doors:_panel_outside_colour"]:checked'
    );
    if (!selectedOutsideColor)
      selectedOutsideColor = this.buyingJourney.querySelector(
        `input[data-variant-id="${this.buyingJourneyObject.panelOutsideColour.variantId}"]`
      );
    this.buyingJourney
      .querySelectorAll('input[name="sliding_doors:_panel_inside_colour"]')
      .forEach((insideColour) => {
        const availableColors = colorOptions[selectedOutsideColor?.value];
        if (availableColors.includes(insideColour.value)) {
          insideColour.closest(".panel-wrapper").classList.remove("hidden");
        } else {
          insideColour.closest(".panel-wrapper").classList.add("hidden");
          insideColour.checked = false;
        }
      });

    if (selectedOutsideColor) {
      this.buyingJourneyObject.panelOutsideColour.value =
        `${selectedOutsideColor.value} ( ${selectedOutsideColor.dataset.ralvalue} )` ||
        null;
      this.buyingJourneyObject.panelOutsideColour.variantId =
        selectedOutsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelOutsideColour.totalPrice =
        this.convertPrice(selectedOutsideColor.dataset.price);
      this.buyingJourneyObject.panelOutsideColour.quantity =
        parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners(
      'input[name="sliding_doors:_panel_inside_colour"]'
    );
  }

  //Step 6: Show Handles and get the selected inside colours
  getInsideColor() {
    console.log("Handles");
    this.setupOptionListeners('input[name="sliding-doors:-handles"]');

    const selectedInsideColor = this.buyingJourney.querySelector(
      'input[name="sliding_doors:_panel_inside_colour"]:checked'
    );

    if (selectedInsideColor) {
      this.buyingJourneyObject.panelInsideColour.value =
        `${selectedInsideColor.value} ( ${selectedInsideColor.dataset.ralvalue} )` ||
        null;
      this.buyingJourneyObject.panelInsideColour.variantId =
        selectedInsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelInsideColour.totalPrice = this.convertPrice(
        selectedInsideColor.dataset.price
      );
      this.buyingJourneyObject.panelInsideColour.quantity =
        parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    if (this.buyingJourneyObject.panelHandle.variantId != null) {
      let selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelHandle.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
  }

  //Step 7: show glass sizes and get the selected handles
  getPanelHandle() {
    const toggleBlinds = (toggle = true) => {
      const windowBlinds = this.buyingJourney.querySelectorAll(
        'input[name="sliding-doors:-blinds"]'
      );
      windowBlinds.forEach((blind) => {
        const blindsPrice =
          this.convertPrice(blind.dataset.price) *
          parseInt(this.buyingJourneyObject.panelSize.value);
        const priceElement = blind
          .closest(".panel-wrapper")
          .querySelector(".panel-price");

        blind.dataset.finalPrice = blindsPrice;
        priceElement && (priceElement.innerHTML = "£" + blindsPrice);
        priceElement && (priceElement.dataset.finalPrice = blindsPrice);
        // check if the panel isOversized or isSixMGlass
        if (blindsPrice > 0 && toggle === false) {
          blind.disabled = true;
          priceElement && (priceElement.innerHTML = "");
          blind.checked = false;
        } else {
          blind.disabled = false;
        }
      });
    };

    const checkForSelectedGlass = (radio) => {
      if (
        radio.value.includes("6.8mm") ||
        radio.value.includes("6mm") ||
        radio.value.includes("Oversized")
      ) {
        this.buyingJourney.skipNextNSteps(1);
        toggleBlinds(false);
      } else {
        this.buyingJourney.unskipNextNSteps(1);
        toggleBlinds(true);
      }
    };

    let hideGlassOptions = null;
    if (this.buyingJourneyObject.panelInfo.isOversized) {
      hideGlassOptions = "oversized";
      console.log("String type: Hide glass options");
    } else if (this.buyingJourneyObject.panelInfo.isSixMGlass) {
      hideGlassOptions = "six-m-glass";
      console.log("Six m glass type: Hide glass options");
    } else {
      hideGlassOptions = null;
      console.log("Not a string type: show all glass options");
    }

    const glassSize =
      (this.buyingJourneyObject.panelInfo.panelWidth / 1000) *
      (this.buyingJourneyObject.panelInfo.panelHeight / 1000);

    const glassSizeOptions = this.buyingJourney.querySelectorAll(
      'input[name="sliding-doors:-glass_size"]'
    );

    glassSizeOptions.forEach((radio) => {
      radio.closest(".panel-wrapper").classList.remove("hidden");
      if (
        hideGlassOptions === "oversized" &&
        !radio.value.includes("Oversized")
      ) {
        radio.closest(".panel-wrapper").classList.add("hidden");
      } else if (
        hideGlassOptions === "six-m-glass" &&
        (!radio.value.includes("6") || radio.value.includes("Oversized"))
      ) {
        radio.closest(".panel-wrapper").classList.add("hidden");
      }
      radio.addEventListener("change", (event) => {
        checkForSelectedGlass(event.currentTarget);
      });

      if (radio && radio.dataset.variantPrice > 0) {
        let totalGlassPrice = Math.round(
          parseFloat(radio.dataset.variantPrice).toFixed(2) * glassSize
        );
        radio.dataset.price = totalGlassPrice;
        let panelPriceElement = radio
          .closest(".panel-wrapper")
          .querySelector(".panel-price");
        if (panelPriceElement) {
          panelPriceElement.innerHTML =
            totalGlassPrice === 0
              ? '<span class="free-badge">Free included </span>'
              : "+£" + totalGlassPrice;
        }
      }
    });

    const selectedHandle = this.buyingJourney.querySelector(
      'input[name="sliding-doors:-handles"]:checked'
    );

    if (selectedHandle) {
      this.buyingJourneyObject.panelHandle.value = selectedHandle.value || null;
      this.buyingJourneyObject.panelHandle.variantId =
        selectedHandle.dataset.variantId || null;
      this.buyingJourneyObject.panelHandle.totalPrice = this.convertPrice(
        selectedHandle.dataset.price
      );
    }

    if (this.buyingJourneyObject.panelGlass.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelGlass.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;

    this.setupOptionListeners('input[name="sliding-doors:-glass_size"]');

    console.log(this.buyingJourneyObject);
  }

  updateGlassValues() {
    //get the selected value for the glass on this step
    const selectedGlassType = this.buyingJourney.querySelector(
      'input[name="sliding-doors:-glass_size"]:checked'
    );
    if (selectedGlassType) {
      this.buyingJourneyObject.panelGlass.value = selectedGlassType.value;
      this.buyingJourneyObject.panelGlass.variantId =
        selectedGlassType.dataset.variantId;
      this.buyingJourneyObject.panelGlass.totalPrice = Math.round(
        this.convertPrice(selectedGlassType.dataset.price)
      );
    }
  }

  //Step 8: Show the Bars fitting type and get the selected glass type.
  getGlassType() {
    console.log("Blinds");

    // Recalculate glass data-price from variantPrice × glassSize.
    // Normally done in getPanelHandle (step 5), but that step does not run
    // when the user edits a quote and jumps directly to this step.
    const glassSize =
      (this.buyingJourneyObject.panelInfo.panelWidth / 1000) *
      (this.buyingJourneyObject.panelInfo.panelHeight / 1000);
    this.buyingJourney.querySelectorAll('input[name="sliding-doors:-glass_size"]').forEach((radio) => {
      if (radio && radio.dataset.variantPrice > 0) {
        const totalGlassPrice = Math.round(parseFloat(radio.dataset.variantPrice).toFixed(2) * glassSize);
        radio.dataset.price = totalGlassPrice;
        const panelPriceElement = radio.closest(".panel-wrapper").querySelector(".panel-price");
        if (panelPriceElement) {
          panelPriceElement.innerHTML =
            totalGlassPrice === 0 ? '<span class="free-badge">Free included </span>' : "+£" + totalGlassPrice;
        }
      }
    });

    // Recalculate blind data-finalPrice from variantPrice × panelCount.
    // Normally done in getPanelHandle (step 5) via toggleBlinds(), but that step
    // does not run when the user edits a quote and jumps directly to this step.
    this.buyingJourney.querySelectorAll('input[name="sliding-doors:-blinds"]').forEach((blind) => {
      const blindsPrice = this.convertPrice(blind.dataset.price) * parseInt(this.buyingJourneyObject.panelSize.value);
      const priceElement = blind.closest(".panel-wrapper").querySelector(".panel-price");
      blind.dataset.finalPrice = blindsPrice;
      if (priceElement) {
        priceElement.innerHTML = "£" + blindsPrice;
        priceElement.dataset.finalPrice = blindsPrice;
      }
    });

    //get the selected value for the glass on this step
    this.updateGlassValues();

    if (this.buyingJourneyObject.blinds.variantId != null || this.buyingJourneyObject.panelGlass.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelGlass.variantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }

      // Pre-select the blind radio based on saved state
      if (this.buyingJourneyObject.blinds.variantId != null) {
        const blindToSelect = this.buyingJourney.querySelector(
          'input[name="sliding-doors:-blinds"][data-variant-id="' +
          this.buyingJourneyObject.blinds.variantId +
          '"]'
        );
        if (blindToSelect) {
          blindToSelect.checked = true;
        }
      }
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    this.buyingJourney.nextStepButton.dataset.increment = 0;
    this.setupOptionListeners('input[name="sliding-doors:-blinds"]');
    console.log(this.buyingJourneyObject);
  }

  getThreshold() {
    console.log("Cill");

    const selectedBlinds = this.buyingJourney.querySelector(
      'input[name="sliding-doors:-blinds"]:checked'
    );

    if (selectedBlinds) {
      this.buyingJourneyObject.blinds.value = selectedBlinds.value;
      this.buyingJourneyObject.blinds.variantId =
        selectedBlinds.dataset.variantId;
      this.buyingJourneyObject.blinds.totalPrice = this.convertPrice(
        selectedBlinds.dataset.finalPrice
      );
    }

    if (this.buyingJourneyObject.cill.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.cill.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    // if the selected panel size is 3 , 6 hide the 190mm cill
    const cill190mm = this.buyingJourney
      .querySelector("#cill-190mm")
      .closest(".panel-wrapper");
    if (["3", "6"].includes(this.buyingJourneyObject.panelSize.value)) {
      cill190mm.classList.add("hidden");
      cill190mm.querySelector("input").checked = false;
    } else {
      cill190mm.classList.remove("hidden");
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
    this.setupOptionListeners('input[name="sliding-doors:-cill"]');
    console.log(this.buyingJourneyObject);
  }

  getBarsFittingQuantity() {
    console.log("Trickle Vents");

    if (this.buyingJourneyObject.trickleVents.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.trickleVents.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedCill = this.buyingJourney.querySelector(
      'input[name="sliding-doors:-cill"]:checked'
    );

    if (selectedCill) {
      this.buyingJourneyObject.cill.value = selectedCill.value;
      this.buyingJourneyObject.cill.variantId = selectedCill.dataset.variantId;
      this.buyingJourneyObject.cill.totalPrice = this.convertPrice(
        selectedCill.dataset.price *
        parseFloat(
          ((this.buyingJourneyObject.panelInfo.panelWidth +
            this.buyingJourneyObject.panelInfo.panelHeight) *
            2) /
          1000
        )
      );
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="sliding-doors:-trickle-vent"]');
  }

  getTrickleVents() {
    console.log("Profile Addons");

    const selectedTrickleOption = this.buyingJourney.querySelector(
      'input[name="sliding-doors:-trickle-vent"]:checked'
    );
    if (selectedTrickleOption) {
      this.buyingJourneyObject.trickleVents.value = selectedTrickleOption.value;
      this.buyingJourneyObject.trickleVents.variantId =
        selectedTrickleOption.dataset.variantId;
      this.buyingJourneyObject.trickleVents.totalPrice = this.convertPrice(
        selectedTrickleOption.dataset.price
      );
    }

    const top_side = this.buyingJourney.querySelector(
      'select[name="top_side"]'
    );

    if (top_side) {
      let selectedTopFrameLength = top_side.options[top_side.selectedIndex];
      this.buyingJourneyObject.profileAddons.top =
        this.buyingJourneyObject.profileAddons.top ||
        selectedTopFrameLength.value;

      top_side.addEventListener("change", () => {
        selectedTopFrameLength = top_side.options[top_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.top =
          selectedTopFrameLength.value;
        this.buyingJourneyObject.profileAddons.topPrice = this.convertPrice(
          selectedTopFrameLength.dataset.price *
          (this.buyingJourneyObject.panelInfo.panelWidth / 1000)
        );
      });
    }

    if (this.buyingJourneyObject.profileAddons.top != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'select[name="top_side"]'
      );
      selectedOption.value = this.buyingJourneyObject.profileAddons.top;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.trickleVents.value == "yes") {
      top_side.selectedIndex = 1;
      top_side.disabled = true;
    } else {
      top_side.disabled = false;
    }
    this.buyingJourney.setActiveNextButton();
    console.log(this.buyingJourneyObject);
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    if (Object.keys(this.buyingJourney.personDetails).length > 0) {
      this.buyingJourneyObject.gtAccessQoute.firstName =
        this.buyingJourney.personDetails.firstName;
      this.buyingJourneyObject.gtAccessQoute.lastName =
        this.buyingJourney.personDetails.lastName;
      this.buyingJourneyObject.gtAccessQoute.email =
        this.buyingJourney.personDetails.email;
      this.buyingJourneyObject.gtAccessQoute.mobile =
        this.buyingJourney.personDetails.phone;
      this.buyingJourneyObject.postCode.value =
        this.buyingJourney.personDetails.postcode;
    }
  }

  getCill() {
    console.log("PostCode");

    this.updateGlassValues(); // make sure we have the latest glass values

    if (this.buyingJourneyObject.postCode.value != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="post-code"]'
      );
      selectedOption.value = this.buyingJourneyObject.postCode.value;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    let classInstance = this;
    const postCodeOptions = this.buyingJourney.querySelector(
      'input[name="post-code"]'
    );
    const postCodeInputs = [postCodeOptions];
    this.disableNextButtonOnEmptyInput(postCodeInputs);

    if (postCodeOptions) {
      postCodeOptions.addEventListener("change", () => {
        classInstance.buyingJourneyObject.postCode.value =
          postCodeOptions.value;
        this.disableNextButtonOnEmptyInput(postCodeInputs);
      });
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  getpostcode() {
    this.updateGlassValues(); // make sure we have the latest glass values
    console.log("Access Issues");
    const accessIssuesOptions = this.buyingJourney.querySelectorAll(
      'input[name="delivery_access_issues"]'
    );
    this.buyingJourney.setDisableNextButton();
    if (accessIssuesOptions) {
      accessIssuesOptions.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.buyingJourney.setDisableNextButton();
          const selectedAccessIssue = this.buyingJourney.querySelector(
            'input[name="delivery_access_issues"]:checked'
          );
          this.buyingJourneyObject.accessIssue.value =
            selectedAccessIssue.value;
          const accessIssueNote = this.buyingJourney.querySelector(
            'textarea[name="access_issues_order_note"]'
          );
          if (this.buyingJourneyObject.accessIssue.value == "Yes") {
            accessIssueNote.addEventListener("change", () => {
              this.buyingJourney.setDisableNextButton();
              this.buyingJourneyObject.accessIssue.orderNote =
                accessIssueNote.value;
              if (
                this.buyingJourneyObject.accessIssue.value == "Yes" &&
                this.buyingJourneyObject.accessIssue.orderNote != null &&
                this.buyingJourneyObject.accessIssue.orderNote.trim() !== ""
              ) {
                this.buyingJourney.setActiveNextButton();
              }
            });
          } else if (this.buyingJourneyObject.accessIssue.value == "No") {
            accessIssueNote.value = null;
            this.buyingJourneyObject.accessIssue.orderNote = null;
            if (
              this.buyingJourneyObject.accessIssue.value == "No" &&
              this.buyingJourneyObject.accessIssue.orderNote == null
            ) {
              this.buyingJourney.setActiveNextButton();
            }
          }
        });
      });
      if (this.buyingJourneyObject.accessIssue.value != null) {
        const selectedOption = this.buyingJourney.querySelector(
          'input[name="delivery_access_issues"][value="' +
          this.buyingJourneyObject.accessIssue.value +
          '"]'
        );
        selectedOption.checked = true;
        if (this.buyingJourneyObject.accessIssue.value == "Yes") {
          this.buyingJourney.querySelector(
            'input[name="access_issues_order_note"]'
          ).value = this.buyingJourneyObject.accessIssue.orderNote;
        }
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    console.log(this.buyingJourneyObject);
  }

  //Gate access
  getGatewayAccessQuote() {
    console.log("Gateway Access");
    if (this.buyingJourneyObject.gtAccessQoute.firstName != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[firstName]"]'
      );
      if (selectedOption) {
        selectedOption.value = this.buyingJourneyObject.gtAccessQoute.firstName;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }
    if (this.buyingJourneyObject.gtAccessQoute.lastName != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[lastName]"]'
      );
      if (selectedOption) {
        selectedOption.value = this.buyingJourneyObject.gtAccessQoute.lastName;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }
    if (this.buyingJourneyObject.gtAccessQoute.email != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[email]"]'
      );
      if (selectedOption) {
        selectedOption.value = this.buyingJourneyObject.gtAccessQoute.email;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    if (this.buyingJourneyObject.gtAccessQoute.mobile != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[phone]"]'
      );
      if (selectedOption) {
        selectedOption.value = this.buyingJourneyObject.gtAccessQoute.mobile;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const accessQuoteInputs =
      this.buyingJourney.querySelectorAll(".step-gtaq input");
    this.disableNextButtonOnEmptyInput(accessQuoteInputs);
    accessQuoteInputs.forEach((input) => {
      input.addEventListener("change", () => {
        switch (input.name) {
          case "contact[firstName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.firstName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.firstName = null;
            }
            break;
          case "contact[lastName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.lastName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.lastName = null;
            }
            break;
          case "contact[phone]":
            {
              const IsValidFormat = this.buyingJourney.validateAndFormatPhone(
                input.value,
                "GB"
              );
              if (input.value.length == 11 && IsValidFormat.valid) {
                this.buyingJourneyObject.gtAccessQoute.mobile = input.value;
                input.classList.remove("invalid");
              } else {
                this.buyingJourneyObject.gtAccessQoute.mobile = null;
                input.classList.add("invalid");
              }
            }
            break;
          case "contact[email]":
            if (this.buyingJourney.validateEmail()) {
              console.log("valid Email");
              this.buyingJourneyObject.gtAccessQoute.email = input.value;
            } else {
              console.log("Invalid Email");
              this.buyingJourneyObject.gtAccessQoute.email = null;
            }
            break;
          default:
            console.log("no input");
            break;
        }

        if (
          this.buyingJourneyObject.gtAccessQoute.firstName &&
          this.buyingJourneyObject.gtAccessQoute.lastName &&
          this.buyingJourneyObject.gtAccessQoute.mobile &&
          this.buyingJourneyObject.gtAccessQoute.email
        ) {
          this.buyingJourney.setActiveNextButton();
        } else {
          this.buyingJourney.setDisableNextButton();
        }
      });
    });
  }

  getProductFinalPrice() {
    this.buyingJourneyObject.totalPrice = Math.round(
      this.convertPrice(
        +this.buyingJourneyObject.panelSize.totalPrice +
        +this.buyingJourneyObject.panelOutsideColour.totalPrice +
        +this.buyingJourneyObject.panelInsideColour.totalPrice +
        +this.buyingJourneyObject.panelHandle.totalPrice +
        +this.buyingJourneyObject.panelGlass.totalPrice +
        +this.buyingJourneyObject.trickleVents.totalPrice +
        +this.buyingJourneyObject.profileAddons.topPrice +
        +this.buyingJourneyObject.cill.totalPrice +
        +this.buyingJourneyObject.blinds.totalPrice
      )
    );
    return this.buyingJourneyObject.totalPrice;
  }

  collectProductData() {
    const productData = {
      title: `Aluminium Sliding Door ${this.buyingJourneyObject.panelInfo.panelWidth}x${this.buyingJourneyObject.panelInfo.panelHeight} | ${this.buyingJourneyObject.panelSize.value} panels`,
      handle: "your-order-" + this.buyingJourney.generateRandomSixDigitNumber(),
      body_html: `
          <p style="text-align: left;"><strong>Access Issues: </strong> ${this.buyingJourneyObject.accessIssue.value == "No"
          ? this.buyingJourneyObject.accessIssue.value
          : this.buyingJourneyObject.accessIssue.orderNote
        }</p>
          <p style="text-align: left;"><strong>Manufacturing Size: </strong> ${this.buyingJourneyObject.panelInfo.panelWidth +
        "x" +
        this.buyingJourneyObject.panelInfo.panelHeight
        }</p>
          <p style="text-align: left;"><strong>Panels: </strong> ${this.buyingJourneyObject.panelInfo.value
        }</p>
          <p style="text-align: left;"><strong>Outside Colour: </strong> ${this.buyingJourneyObject.panelOutsideColour.value
        }</p>
          <p style="text-align: left;"><strong>Inside Colour: </strong> ${this.buyingJourneyObject.panelInsideColour.value
        }</p>
          <p style="text-align: left;"><strong>Cill: </strong>${this.buyingJourneyObject.cill.value
        }</p>
          <p style="text-align: left;"><strong>Glass: </strong>${this.buyingJourneyObject.panelGlass.value
        }</p>
          <p style="text-align: left;"><strong>Blinds: </strong>${this.buyingJourneyObject.blinds.value
        }</p>
          <p style="text-align: left;"><strong>Handle Colour: </strong>${this.buyingJourneyObject.panelHandle.value
        }</p>
          <p style="text-align: left;"><strong>Trickle Vents: </strong>${this.buyingJourneyObject.trickleVents.value
        }</p>
          <p style="text-align: left;"><strong>Top Addon: </strong>${this.buyingJourneyObject.profileAddons.top
        }</p>
         
          <p style="text-align: left;"><strong>Total price:</strong> £${this.getProductFinalPrice()} </p>
          `,
      vendor: "NOW Aluminium",
      product_type: "quote-product",
      variants: [
        {
          price: this.getProductFinalPrice(),
        },
      ],
      images: [
        {
          src: this.buyingJourneyObject.panelSize.panelImage, // Assuming this is the URL to the product image
        },
      ],
      properties: this.getProductProperties(),
    };
    return productData;
  }

  //Helper Functions

  validateInput(productObject, input) {
    const { buyingJourney } = this;
    if (input) {
      switch (input.name) {
        case "panel-width":
          productObject.panelInfo.panelWidth = parseInt(input.value, 10) || 0;
          break;
        case "panel-height":
          productObject.panelInfo.panelHeight = parseInt(input.value, 10) || 0;
        default:
          break;
      }
      var isValid = true;
      const value = parseInt(input.value, 10);
      if (!isNaN(value)) {
        isValid = true;
        if (input.hasAttribute("min") && input.hasAttribute("max")) {
          isValid = value >= input.min && value <= input.max;
        }
      }
      input.classList.toggle("invalid", !isValid);
      if (input.parentElement.nextElementSibling) {
        input.parentElement.nextElementSibling.classList.toggle(
          "show",
          !isValid
        );
      }
      if (this.validateStep()) {
        return true;
      } else {
        return false;
      }
    }
  }

  setIncrementForButtons(selectedFitting) {
    switch (selectedFitting) {
      case "yes":
        this.buyingJourney.nextStepButton.dataset.increment = 0;
        break;
      case "no":
        this.buyingJourney.nextStepButton.dataset.increment = 2;
        break;
      default:
        // do nothing
        break;
    }
  }

  setDecrementForButtons(selectedFitting) {
    const { buyingJourney } = this;
    switch (selectedFitting) {
      case "yes":
        this.buyingJourney.prevStepButton.dataset.decrement = 0;
        break;
      case "no":
        this.buyingJourney.prevStepButton.dataset.decrement = 2;
        break;
      case "skipAstragal":
        this.buyingJourney.prevStepButton.dataset.decrement = 3;
        break;
      default:
        // do nothing
        break;
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
  }

  validateStep() {
    const activeInputs = this.buyingJourney.querySelectorAll(
      ".step-container.active input"
    );
    return Array.from(activeInputs).every(
      (input) => input && input.value && !input.classList.contains("invalid")
    );
  }

  setupOptionListeners(selector) {
    const options = this.buyingJourney.querySelectorAll(selector);
    options.forEach((option) =>
      option.addEventListener("change", () => {
        if (option) option.checked = true;
        this.disableNextButtonOnNonSelection(options);
      })
    );
    this.disableNextButtonOnNonSelection(options);
  }

  disableNextButtonOnNonSelection(options) {
    const anyChecked = Array.from(options).some(
      (option) => option && option.checked
    );
    if (anyChecked) {
      this.buyingJourney.setActiveNextButton();
    } else {
      this.buyingJourney.setDisableNextButton();
    }
  }

  convertPrice(price) {
    let priceRounded;
    if (price) {
      let decimalPrice = parseFloat(price); // Convert the price to a float
      priceRounded = Math.round(decimalPrice * 100.0) / 100; // Multiply by 100, round, then divide by 100
    } else {
      priceRounded = 0;
    }
    return priceRounded;
  }

  disableNextButtonOnEmptyInput(inputs) {
    const allFilled = Array.from(inputs).every(
      (input) => input && input.value.trim() !== ""
    );
    let classInstance = this;
    if (allFilled) {
      classInstance.buyingJourney.setActiveNextButton();
    } else {
      classInstance.buyingJourney.setDisableNextButton();
    }
  }

  getProductProperties() {
    return {
      "First name": `${this.buyingJourneyObject.gtAccessQoute.firstName}`,
      "Last name": `${this.buyingJourneyObject.gtAccessQoute.lastName}`,
      Email: `${this.buyingJourneyObject.gtAccessQoute.email}`,
      Phone: `${this.buyingJourneyObject.gtAccessQoute.mobile}`,
      Postcode: `${this.buyingJourneyObject.postCode}`,
      "Product type": `${this.buyingJourneyObject.productType}`,
      "Panel width": `${this.buyingJourneyObject.panelInfo.panelWidth}`,
      "Panel height": `${this.buyingJourneyObject.panelInfo.panelHeight}`,
      panels: `${this.buyingJourneyObject.panelInfo.value}`,
      "Panel outside color": `${this.buyingJourneyObject.panelOutsideColour.value}`,
      "Panel inside color": `${this.buyingJourneyObject.panelInsideColour.value}`,
      "Panel handle": `${this.buyingJourneyObject.panelHandle.value}`,
      "Panel glass": `${this.buyingJourneyObject.panelGlass.value}`,
      Blinds: `${this.buyingJourneyObject.blinds.value}`,
      "Trickle vents": `${this.buyingJourneyObject.trickleVents.value}`,
      "Profile addons top": `${this.buyingJourneyObject.profileAddons.top}`,
      Postcode: `${this.buyingJourneyObject.postCode.value}`,
      Cill: `${this.buyingJourneyObject.cill.value}`,
      "Access issues": `${this.buyingJourneyObject.accessIssue.value}`,
      "Access issues note": `${this.buyingJourneyObject.accessIssue.orderNote}`,
      "Panel image": `${this.buyingJourneyObject.panelSize.panelImage}`,
      "Verified Email": `${this.buyingJourney.emailVerified}`,
      _buyingJourneyObject: this.buyingJourney.TokenUtils.encode(this.buyingJourneyObject),

    };
  }

  convertOrderItemsIntoProductObject(orderItem) {
    const props = orderItem.properties || {};
    let _buyingJourneyObject = null;
    if (props["_buyingJourneyObject"]) {
      if (!props["_buyingJourneyObject"].includes("{")) {
        _buyingJourneyObject = this.buyingJourney.TokenUtils.decode(props["_buyingJourneyObject"]);
      } else {
        _buyingJourneyObject = JSON.parse(props["_buyingJourneyObject"]);
      }
    }
    return {
      id: orderItem.id,
      product_id: orderItem.product_id,

      title: orderItem.product_title,
      totalPrice: orderItem.price,

      panelSize: {
        panelImage: orderItem.image || orderItem.properties["Panel image"],
        value: props["No. of panels"],
      },

      panelInfo: {
        panelWidth: props["Panel width"],
        panelHeight: props["Panel height"],
        value: props["panels"],
      },

      panelOutsideColour: { value: props["Panel outside color"] },
      panelInsideColour: { value: props["Panel inside color"] },
      panelHandle: { value: props["Panel handle"] },
      panelGlass: { value: props["Panel glass"] },
      blinds: { value: props["Blinds"] },

      trickleVents: { value: props["Trickle vents"] },

      profileAddons: {
        top: props["Profile addons top"],
        value: props["Profile addons"],
      },

      postCode: { value: props["Postcode"] },
      cill: { value: props["Cill"] },

      accessIssue: {
        value: props["Access issues"],
        orderNote: props["Access issues note"],
      },

      gtAccessQoute: {
        firstName: props["First name"],
        lastName: props["Last name"],
        mobile: props["Phone"],
        email: props["Email"],
      },

      productType: props["Product type"],
      _buyingJourneyObject: {
        ..._buyingJourneyObject,
        id: orderItem.id,
        product_id: orderItem.product_id,
        title: this.buyingJourneyObject.title,
      },
    };
  }
  // Create individual quote item element
  createQuoteItemElement(item) {
    const { buyingJourney } = this;

    // Safely extract all needed values with defaults
    const title = item?.title ?? "";
    const totalPrice = item?.totalPrice ?? 0;
    const panelImage = item?.panelSize?.panelImage ?? "";
    const panelWidth = item?.panelInfo?.panelWidth ?? "";
    const panelHeight = item?.panelInfo?.panelHeight ?? "";
    const outsideColour = item?.panelOutsideColour?.value ?? "";
    const accessOrderNote = item?.accessIssue?.orderNote;
    const accessIssueText =
      !accessOrderNote || accessOrderNote === "null" ? "No" : accessOrderNote;
    const topAddon = item?.profileAddons?.top ?? "";
    const handleColour = item?.panelHandle?.value ?? "";
    const trickleVents = item?.trickleVents?.value ?? "";
    const panelsValue = item?.panelInfo?.value ?? "";
    const insideColour = item?.panelInsideColour?.value ?? "";
    const glass = item?.panelGlass?.value ?? "";
    const cillValue = item?.cill?.value;
    const cill = !cillValue || cillValue === "null" ? "No" : cillValue;
    const blindsValue = item?.blinds?.value;
    const blinds = !blindsValue || blindsValue === "null" ? "No" : blindsValue;
    const delivery = "Standard"; // constant in original

    const div = document.createElement("div");
    div.className = "bj-cart-bottom";
    div.innerHTML = `
        <div class="bj-cart-bottom-right-top accordion-toggle">
          <div class="cart-accor-header-left">
            <h2 class="bj-cart-heading">${title}</h2>
            <div class="bj-cart-total-price">
              <span class="bj-cart-price" data-price="${item.totalPrice
      }" data-order-price>${Shopify.formatMoney(totalPrice)}</span>
              <span class="bj-cart-price-text">+ VAT</span>
            </div>
          </div>
          <div class="cart-accor-header-right">
          <a class="bj-cart-image-text removeQuoteProduct" data-item-id="${item.id
      }" data-product-id="${item.product_id}">
              <span>Remove</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <rect x="21.8047" y="0.199219" width="21.601" height="21.601" rx="10.8005" transform="rotate(90 21.8047 0.199219)" fill="#967b50"/>
                <path d="M8.45014 7.98345L14.0186 7.98345L14.0186 13.5519M13.6319 8.37015L7.9861 14.016" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
            <button type="button" class="accordion-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
              <rect y="0.224609" width="28" height="28" rx="14" fill="#967b50"></rect>
              <path d="M7.51465 15.8193L13.9999 9.33398L20.4852 15.8193" stroke="#f1f1f1" stroke-width="1.64706" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            </button>
          </div>
        </div>
        <div class="bj-cart-bottom-in">
          <div class="bj-cart-bottom-in-left">
            <div class="cart-item-image">
              <img id="order-featured-image" src="${panelImage}" alt="${title}" class="bj-cart-image" />
            </div>
          </div>
          <div class="bj-cart-bottom-in-right">
            <div class="bj-cart-bottom-right-center">
              <h3 class="bj-cart-detail-heading">Your door</h3>
              <div class="bj-cart-details">
                ${buyingJourney.renderDetail(
        "Manufacturing size (mm)",
        `${panelWidth} x ${panelHeight}`,
        "1",
        1
      )}
                ${buyingJourney.renderDetail(
        "Outside colour",
        outsideColour,
        "4",
        3
      )}
                ${buyingJourney.renderDetail(
        "Access issues",
        accessIssueText,
        "17",
        12
      )}
                ${buyingJourney.renderDetail("Top addon", topAddon, "13", 10)}
                ${buyingJourney.renderDetail(
        "Handle colour",
        handleColour,
        "5",
        5
      )}
                ${buyingJourney.renderDetail(
        "Trickle vents",
        trickleVents,
        "9",
        9
      )}
                ${buyingJourney.renderDetail("Panels", panelsValue, "2", 2)}
                ${buyingJourney.renderDetail(
        "Inside colour",
        insideColour,
        "9",
        4
      )}
                ${buyingJourney.renderDetail("Glass", glass, "6", 6)}
                ${buyingJourney.renderDetail("Cill", cill, "8", 8)}
                ${buyingJourney.renderDetail("Blinds", blinds, "7", 7)}
                ${buyingJourney.renderDetail("Delivery", delivery, "", "0")}
              </div>
            </div>
          </div>
        </div>
      `;

    // Attach remove handler
    // div
    //   .querySelector('.removeQuoteProduct')
    //   ?.addEventListener('click', () => buyingJourney.removeQuoteProduct(item.id, item.product_id));

    div.querySelectorAll(".edit-option")?.forEach((option) =>
      option.addEventListener("click", () => {
        this.editHandler(option, item);
      })
    );

    return div;
  }

  editHandler(input, object) {
    const draftOrderId = this.buyingJourney.draftOrderId;
    const stepIndex = input.dataset.stepCount;
    // write an object to the localestoarge
    const editObject = {
      object,
      draftOrderId,
    };
    localStorage.setItem("modified-product", JSON.stringify(editObject));
    window.location.href = `/pages/sliding-doors-builder?step=${stepIndex}&edit-order=true`;
  }
}

window.SlidingDoor = SlidingDoor;
